
import { app } from 'general';
import { BaseComponent } from 'project/general';
import { resourceLoader } from 'project/resource-loader';

export default class HubspotFormComponent extends BaseComponent {

    static getNamespace() {
        return 'hubspot-form-widget';
    }

    loqateApi = null;

    onInit() {

        resourceLoader.load(app.getConfig('hubSpot').resources).then(() => {

            window.addEventListener("hs-form-event:on-ready", event => {
                const { formId, instanceId } = event.detail;

                this.hubSpotFormReady = true;

                this.initialiseLoqateApi(event);

                window.onAddressSelected = this.onAddressSelected;


            });

        });

    }

    initialiseLoqateApi(event) {

        this.readyPromise = resourceLoader.load(app.getConfig('loqate').resources)
            .then(() => {

                var hubspotForm = HubSpotFormsV4.getFormFromEvent(event);

                var getHubspotFields = hubspotForm.getFormFieldValues().then((hubspotFields) => {

                    var loqateFields = [];

                    //  create array of fields for loqate api
                    for (var i = 0; i < hubspotFields.length; i++) {
                        var loqateField = this.getLoqateField(hubspotFields[i].name);
                        if (loqateField != undefined) {
                            loqateFields.push(loqateField);
                        }
                    }

                    //  initialise loqate api
                    var options = { key: app.getConfig('loqate').apiKey }
                    this.loqateApi = new pca.Address(loqateFields, options);

                    // ensure HubSpot doesn't destroy the address values dynamically set by loqate
                    this.loqateApi.listen("populate", function (address) {
                        window.onAddressSelected(hubspotForm, address);
                    });

                });

            });

    }

    onAddressSelected = (hubspotForm, data) => {

        var loqateFields = this.loqateApi.fields;

        for (var i = 0; i < loqateFields.length; i++) {

            var loqateField = loqateFields[i];
            var inputName = loqateField.element;

            hubspotForm.setFieldValue(inputName, data[loqateField.field]);

            var input = document.getElementsByName(inputName)[0];
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));

        }

    };

    getLoqateField(hubspotFieldName) {

        if (hubspotFieldName != undefined && hubspotFieldName != null) {

            var loqateField = {};
            loqateField.element = hubspotFieldName;

            if (hubspotFieldName.includes("/address_line_4")) {
                loqateField.field = "Line4";
                loqateField.mode = pca.fieldMode.POPULATE;
            }
            else if (hubspotFieldName.includes("/address_line_3")) {
                loqateField.field = "Line3";
                loqateField.mode = pca.fieldMode.POPULATE;
            }
            else if (hubspotFieldName.includes("/address_line_2")) {
                loqateField.field = "Line2";
                loqateField.mode = pca.fieldMode.POPULATE;
            }
            else if (hubspotFieldName.includes("/address")) {
                loqateField.field = "Line1";
                loqateField.mode = pca.fieldMode.DEFAULT;
            }
            else if (hubspotFieldName.includes("/city")) {
                loqateField.field = "City";
                loqateField.mode = pca.fieldMode.POPULATE;
            }
            else if (hubspotFieldName.includes("/zip")) {
                loqateField.field = "PostalCode";
                loqateField.mode = pca.fieldMode.DEFAULT;
            }
            else if (hubspotFieldName.includes("/country")) {
                loqateField.field = "CountryName";
                loqateField.mode = pca.fieldMode.POPULATE;
            }
            else {
                return undefined;
            }

            return loqateField;
        }
    }

}
